module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 44
// module chunks = 0